import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AdminPartner } from '@core/models/iam/admin-partner.model';
import { AuthService } from '@core/services/auth/auth.service';
import { StoreService } from '@core/services/store/store.service';
import { environment } from '@env';
import { AAGUID, Browser, SsrService } from '@interticket/core';

@Component({
  selector: 'lib-profile-dropdown',
  templateUrl: './profile-dropdown.component.html',
  styleUrls: ['./profile-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileDropdownComponent {

  readonly currentAdminPartner: AdminPartner = this.storeService.availableAdminPartners.find(partner => partner.current);
  readonly availableAdminPartners: AdminPartner[] = this.storeService.availableAdminPartners.filter(partner => !partner.current);
  readonly sitePartnerId: AAGUID = this.storeService.partnerConfig.partnerId;

  constructor(
    private authService: AuthService,
    private storeService: StoreService,
    private ssrService: SsrService
  ) { }

  login(): void {
    this.authService.redirectToLoginPage();
  }

  logout(): void {
    this.authService.redirectToLogoutPage();
  }

  @Browser()
  goToProfile(): void {
    this.ssrService.location.href = this.authService.accountSiteBaseUrl + environment.auth.profileUrlPath + '?partnerId=' + this.sitePartnerId + '&cancelUrl=' + encodeURIComponent(this.ssrService.location.href);
  }

  getAdminSiteUrl(partnerId: AAGUID, confirmIdentity: boolean): string {
    return this.authService.getAdminSiteUrl(partnerId, confirmIdentity);
  }

}

